import React from 'react';
import cn from 'classnames';
import Link from '@/Framework/Router/Next/Link/Link';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import { BWICS, INVENTORIES } from '@/finsight/domain/BondType';
import { IPositionItem } from '@/finsight/domain/vo/PortfolioMonitor/IPositionsCollection';
import { usePositionsContext } from '@/finsight/application/PortfolioMonitor/PositionsContext';

import styles from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/PositionsTable/tooltipStyles.scss';
import dealLinkStyles from './styles.scss';
import tableStyles from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/PositionsTable/positionsTable.scss';

enum CountType {
  live = 'Live',
  historical = 'Historical',
}

const BondTypeNames = {
  [BWICS]: 'BWICs',
  [INVENTORIES]: 'Inventory',
};

const getDealCounts = (position: IPositionItem, bondType: string): [number, number] => {
  const {
    liveBwicsCount,
    historicalBwicsCount,
    liveInventoriesCount,
    historicalInventoriesCount,
  } = position;

  const bondTypeCountsMap = {
    [BWICS]: [liveBwicsCount, historicalBwicsCount],
    [INVENTORIES]: [liveInventoriesCount, historicalInventoriesCount],
  };

  return bondTypeCountsMap[bondType];
};

const DealLinkWithStatus = ({
  path,
  row,
  cellData,
  bondType = '',
}) => {
  const { cusip } = row;
  const [liveCount, historicalCount] = getDealCounts(row, bondType);
  const { selection: { collection: selectedRows } } = usePositionsContext();
  const isCheckedLiveBond = selectedRows.includes(cusip) && liveCount;

  const renderCount = (countType: string, count: number) => (
    <div key={ countType }>
      <span className={ cn(styles.name, dealLinkStyles.tooltipName) }>
        # of { countType } { BondTypeNames[bondType] }
      </span>
      <span className={ styles.value }>{ count }</span>
    </div>
  );

  const tooltipContent = (
    <div className={ styles.tooltipBox }>
      { renderCount(CountType.live, liveCount) }
      { renderCount(CountType.historical, historicalCount) }
    </div>
  );

  const cellStyles = cn(
    dealLinkStyles.countCell, {
      [tableStyles.liveBondCell]: liveCount,
      [tableStyles.checkedCell]: isCheckedLiveBond,
    });

  return (
    <div className={ cellStyles }>
      { cellData ? (
        <Tooltip
          placement="bottom"
          content={ tooltipContent }
          disabled={ !tooltipContent }
        >
          <Link
            to={ `${ path }?q=${ cusip }` }
            target="_blank"
          >
            { cellData }
          </Link>
        </Tooltip>
      ) : '-' }
    </div>
  );
};

export default DealLinkWithStatus;
